import { getView, setView, on, syncSegmented } from '@lucid/core';

class LucidViewToggle extends HTMLElement {
  #off = null;
  #observer = new MutationObserver(() => {
    if (!this.#inSync()) this.#sync();
  });

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.#off = on('view:change', () => this.#sync());
    this.#sync();
    this.#observer.observe(this, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.#off?.();
    this.#observer.disconnect();
  }

  #inSync() {
    const view = getView();
    for (const button of this.querySelectorAll('[data-view-flip]')) {
      if (button.getAttribute('aria-pressed') !== String(view === 'model')) return false;
    }
    for (const option of this.querySelectorAll('.lucid-segmented__option')) {
      if (option.getAttribute('aria-pressed') !== String(option.dataset.value === view)) return false;
    }
    return true;
  }

  #onClick = (event) => {
    const flip = event.target instanceof Element ? event.target.closest('[data-view-flip]') : null;
    if (!flip) return;
    event.preventDefault();
    setView(getView() === 'model' ? 'product' : 'model');
  };

  #sync() {
    const view = getView();
    for (const button of this.querySelectorAll('[data-view-flip]')) {
      button.setAttribute('aria-pressed', String(view === 'model'));
    }
    if (this.querySelector('[data-lucid-segmented="view"]')) syncSegmented('view', view);
  }
}

if (!customElements.get('lucid-view-toggle')) customElements.define('lucid-view-toggle', LucidViewToggle);
